import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { AwsClient } from 'aws4fetch';
var ERROR_STATE = 'error';
var WAITING_STATE = 'waiting';
var SENDING_STATE = 'sending';
var SENT_STATE = 'sent';
var REACHED_MAX_FAILURES = 'reached_max_failures';
var MAX_FAILED_ATTEMPTS = 3;
var StreamQueue = /*#__PURE__*/function () {
  function StreamQueue(_ref) {
    var config = _ref.config,
      kinesis = _ref.kinesis,
      proxyDomain = _ref.proxyDomain;
    _classCallCheck(this, StreamQueue);
    this.config = config;
    this.kinesis = kinesis;
    this.proxyDomain = proxyDomain;
    this.timeout = null;
    this.pageQueue = [];
    this.awsClient = new AwsClient({
      accessKeyId: kinesis.config.credentials.accessKeyId,
      secretAccessKey: kinesis.config.credentials.secretAccessKey,
      sessionToken: kinesis.config.credentials.sessionToken,
      region: kinesis.config.region,
      service: 'execute-api'
    });
    this._addPage();
    this._scheduleSendRecords();
  }
  return _createClass(StreamQueue, [{
    key: "push",
    value: function push(eventType, data) {
      var event = this._buildRecord(eventType, data);
      if (this._canEnqueueToPage(this._lastPage())) {
        this._lastPage().data.push(event);
        this._sendIfLastPageFull();
      } else {
        this._sendRecords();
        this._addPage();
        this._lastPage().data.push(event);
      }
      return true;
    }

    // =============
    // PRIVATE
    // =============
  }, {
    key: "_scheduleSendRecords",
    value: function _scheduleSendRecords() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this._sendRecords.bind(this), this.config.sendRecordsTimeout);
    }
  }, {
    key: "_sendIfLastPageFull",
    value: function _sendIfLastPageFull() {
      if (this._lastPage().data.length === this.config.maxPageSize) {
        this._sendRecords();
        this._addPage();
      }
    }
  }, {
    key: "_canEnqueueToPage",
    value: function _canEnqueueToPage(page) {
      return page.status === WAITING_STATE && page.data.length < this.config.maxPageSize;
    }
  }, {
    key: "_lastPage",
    value: function _lastPage() {
      return this.pageQueue[this.pageQueue.length - 1];
    }
  }, {
    key: "_addPage",
    value: function _addPage() {
      this.pageQueue.push({
        status: WAITING_STATE,
        data: []
      });
    }
  }, {
    key: "_buildRecord",
    value: function _buildRecord(eventType, data) {
      var builder = this.config.eventTypes[eventType];
      if (typeof builder !== 'function') {
        throw new Error("Unable to retrieve a builder function for event type: ".concat(eventType));
      }
      try {
        return builder(data);
      } catch (e) {
        throw new Error("Unable to build a record for data: ".concat(JSON.stringify(data), "\n").concat(e));
      }
    }
  }, {
    key: "_canSendPage",
    value: function _canSendPage(page) {
      return (page.status === WAITING_STATE || page.status === ERROR_STATE) && page.data.length;
    }
  }, {
    key: "_sendRecordsViaProxy",
    value: function _sendRecordsViaProxy(params) {
      if (!this.proxyDomain) return;
      var encodedParams = _objectSpread(_objectSpread({}, params), {}, {
        Records: params.Records.map(function (record) {
          return _objectSpread(_objectSpread({}, record), {}, {
            Data: btoa(record.Data)
          });
        })
      });
      this.awsClient.fetch(this.proxyDomain, {
        method: 'PUT',
        body: JSON.stringify(encodedParams)
      });
    }
  }, {
    key: "_sendRecords",
    value: function _sendRecords() {
      var _this = this;
      this.pageQueue.forEach(function (page, i) {
        if (!_this._canSendPage(page)) return;
        var params = {
          Records: page.data,
          StreamName: _this.config.stream
        };
        _this.pageQueue[i].status = SENDING_STATE;
        _this.kinesis.putRecords(params, function (err, data) {
          if (err) {
            _this.pageQueue[i].status = ERROR_STATE;
            _this.pageQueue[i].errorCount = (_this.pageQueue[i].errorCount || 0) + 1;
            console.error("KINESIS STREAM ".concat(_this.config.stream, " ERROR: "), err);
            if (_this.pageQueue[i].errorCount >= MAX_FAILED_ATTEMPTS) {
              _this.pageQueue[i].status = REACHED_MAX_FAILURES;
              _this._sendRecordsViaProxy(params);
            }
          } else {
            _this.pageQueue[i].status = SENT_STATE;
            // eslint-disable-next-line no-console
            console.log("KINESIS STREAM ".concat(_this.config.stream, " STATUS: "), "".concat(page.data.length, " items sent successfully"));
          }
        });
      });
      this._scheduleSendRecords();
    }
  }]);
}();
export { StreamQueue as default };